// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-list[data-v-b51a6978],.task-list-selected[data-v-b51a6978]{border-radius:5px;padding:8px 8px;cursor:pointer}.task-list-selected[data-v-b51a6978]:hover,.task-list[data-v-b51a6978]:hover{border-color:#568dfa}.task-list[data-v-b51a6978]{border:1px solid hsla(0,0%,80%,.8)}.task-list-selected[data-v-b51a6978]{border:1px solid #2058c9}", ""]);
// Exports
module.exports = exports;
